/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * AggregationHistogram is the grouping of project energy as well as productivity data.
 */
export var AggregationHistogram;
(function (AggregationHistogram) {
    AggregationHistogram["ENERGY"] = "energy";
    AggregationHistogram["PRODUCTIVITY"] = "productivity";
})(AggregationHistogram || (AggregationHistogram = {}));
